// 页面标题（后台规范 §2）：左边标题 + 一句说明，右边主操作
import type { ReactNode } from "react";

export function PageHeading({ title, desc, children }: { title: ReactNode; desc?: ReactNode; children?: ReactNode }) {
  return (
    <div className="page-heading">
      <div>
        <h1>{title}</h1>
        {desc && <p>{desc}</p>}
      </div>
      {children && <div className="row">{children}</div>}
    </div>
  );
}
